import { ExtendedSecurity } from '@swarm/types/normalized-entities'
import { MaxInputProps } from '@swarm/ui/swarm/MaxInput'
import { Flex } from 'rimble-ui'
import styled from 'styled-components/macro'

import SecuritySelector from './SecuritySelector'
import StakeAmountInput from './StakeAmountInput'

const InputWrapper = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors['light-gray']};
  border-radius: 4px;
  overflow: hidden;
  height: 52px;
  align-items: center;

  &:hover {
    box-shadow: 0px 1px 3px rgb(0 0 0 / 30%);
  }

  &:focus-within {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }

  ${({ error, theme }) =>
    error &&
    `
  border-color: ${theme.colors.danger};

  &:focus, &:focus-within {
    border-color: ${theme.colors.danger};
  } 
`}
`

interface StakeSecurityInputProps extends MaxInputProps {
  onAmountChange?: (value: number, stringValue: string) => void
  onTokenChange: (token: ExtendedSecurity) => void
  selectedToken: ExtendedSecurity | null
  tokens: ExtendedSecurity[]
  tokensLoading: boolean
}

const StakeSecurityInput = ({
  value,
  onAmountChange,
  onTokenChange,
  selectedToken,
  tokens,
  tokensLoading,
  error,
  ...props
}: StakeSecurityInputProps) => {
  return (
    <InputWrapper>
      <SecuritySelector
        onSelection={onTokenChange}
        selected={selectedToken}
        tokens={tokens}
        loading={tokensLoading}
        readonly={tokensLoading || tokens.length === 1}
      />
      <StakeAmountInput
        value={value}
        onChange={onAmountChange}
        error={error}
        disabled={false}
        reportError
        {...props}
      />
    </InputWrapper>
  )
}

export default StakeSecurityInput
